<template>
  <footer class="footer">
    <div class="container">
      <!-- Footer Content Grid -->
      <div class="footer-content">
        <!-- Brand Section -->
        <div class="footer-brand-section">
          <router-link to="/" class="footer-brand">
            <h1 class="footer-logo">Your Cars LLC</h1>
          </router-link>
          <p class="footer-tagline">
            Your trusted partner in finding and financing the car of your dreams
            with ease and transparency.
          </p>
        </div>

        <!-- Quick Links Section -->
        <div class="footer-links-section">
          <h3 class="footer-heading">Quick Links</h3>
          <ul class="footer-links-list">
            <li>
              <router-link to="/" class="footer-link">Home</router-link>
            </li>
            <li>
              <router-link to="/inventory" class="footer-link"
                >Inventory</router-link
              >
            </li>
            <li>
              <router-link to="/#about" class="footer-link"
                >About Us</router-link
              >
            </li>
            <li>
              <router-link to="/#contact" class="footer-link"
                >Contact</router-link
              >
            </li>
          </ul>
        </div>

        <!-- Contact Section -->
        <div class="footer-contact-section">
          <h3 class="footer-heading">Contact Us</h3>
          <ul class="footer-contact-list">
            <li class="footer-contact-item">
              <div class="contact-icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <path
                    d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"
                  ></path>
                </svg>
              </div>
              <a href="tel:+14243334220" class="footer-link"
                >+1 (424) 333-4220</a
              >
            </li>
            <li class="footer-contact-item">
              <div class="contact-icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <path
                    d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"
                  ></path>
                  <polyline points="22,6 12,13 2,6"></polyline>
                </svg>
              </div>
              <a href="mailto:info@yourcarsllc.com" class="footer-link"
                >info@yourcarsllc.com</a
              >
            </li>
            <li class="footer-contact-item">
              <div class="contact-icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <path
                    d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"
                  ></path>
                  <circle cx="12" cy="10" r="3"></circle>
                </svg>
              </div>
              <address class="footer-address">
                4123 San Fernando Rd<br />
                GLENDALE, CA 91204
              </address>
            </li>
          </ul>
        </div>

        <!-- Business Info Section -->
        <div class="footer-info-section">
          <h3 class="footer-heading">Business Hours</h3>
          <div class="hours-container">
            <div class="day-group">
              <p class="day">Monday - Friday:</p>
              <p class="hours">9:00 AM - 7:00 PM</p>
            </div>
            <div class="day-group">
              <p class="day">Saturday:</p>
              <p class="hours">10:00 AM - 6:00 PM</p>
            </div>
            <div class="day-group">
              <p class="day">Sunday:</p>
              <p class="hours">Closed</p>
            </div>
          </div>
        </div>
      </div>

      <!-- Footer Bottom -->
      <div class="footer-bottom">
        <p class="footer-copyright">
          © 2025 Your Cars LLC. All rights reserved. Built with code & coffee by
          <a
            href="https://vision-lab.studio/"
            target="_blank"
            class="legal-link"
          >
            Vision Lab </a
          >.
        </p>
        <div class="footer-legal-links">
          <a href="/privacy" class="legal-link">Privacy Policy</a>
          <span class="separator">|</span>
          <a href="/terms" class="legal-link">Terms of Service</a>
        </div>
      </div>
    </div>
    <div class="footer-wave">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 1440 320"
        preserveAspectRatio="none"
      >
        <path
          fill="#09283f"
          fill-opacity="0.05"
          d="M0,96L48,112C96,128,192,160,288,160C384,160,480,128,576,122.7C672,117,768,139,864,149.3C960,160,1056,160,1152,138.7C1248,117,1344,75,1392,53.3L1440,32L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"
        ></path>
      </svg>
    </div>
  </footer>
</template>

<script>
export default {
  name: "FooterComponent",
};
</script>

<style lang="scss" scoped>
.footer {
  position: relative;
  padding: 100px 0 30px;
  background: #f9f9f9;
  color: #1a1a2e;
  overflow: hidden;

  &:before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 4px;
    background: linear-gradient(90deg, #09283f, #ee800a);
  }

  .footer-wave {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 150px;
    z-index: 0;

    svg {
      width: 100%;
      height: 100%;
    }
  }

  .container {
    width: 100%;
    max-width: 1280px;
    margin: 0 auto;
    padding: 0 2rem;
    position: relative;
    z-index: 1;
  }

  .footer-content {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 3rem;
    margin-bottom: 4rem;

    @media (max-width: 1200px) {
      grid-template-columns: repeat(2, 1fr);
    }

    @media (max-width: 768px) {
      grid-template-columns: 1fr;
      gap: 2.5rem;
    }
  }

  .footer-brand-section {
    .footer-brand {
      display: inline-block;
      margin-bottom: 1.5rem;
      text-decoration: none;

      .footer-logo {
        font-size: 2.2rem;
        font-weight: 700;
        letter-spacing: -0.5px;
        color: #111;
        margin: 0;
        transition: all 0.3s ease;
        background: linear-gradient(135deg, #ee800a, #ff7043);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
        text-fill-color: transparent;

        @media (max-width: 768px) {
          font-size: 1.9rem;
        }
      }

      &:hover {
        transform: translateY(-2px);
      }
    }

    .footer-tagline {
      font-size: 1.05rem;
      line-height: 1.7;
      color: #4a4a4a;
      margin-bottom: 1.8rem;
    }

    .social-icons {
      display: flex;
      gap: 1rem;

      .social-icon {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 40px;
        height: 40px;
        border-radius: 50%;
        background: white;
        color: #09283f;
        box-shadow: 0 4px 10px rgba(0, 0, 0, 0.05);
        transition: all 0.3s ease;

        svg {
          width: 18px;
          height: 18px;
        }

        &:hover {
          background: #ee800a;
          color: white;
          transform: translateY(-3px);
          box-shadow: 0 6px 15px rgba(238, 128, 10, 0.2);
        }
      }
    }
  }

  .footer-heading {
    font-size: 1.4rem;
    font-weight: 600;
    margin-bottom: 1.8rem;
    color: #09283f;
    position: relative;
    padding-bottom: 0.75rem;

    &:after {
      content: "";
      position: absolute;
      bottom: 0;
      left: 0;
      width: 50px;
      height: 3px;
      background: linear-gradient(to right, #ee800a, #ff7043);
      border-radius: 2px;
    }
  }

  .footer-links-section {
    .footer-links-list {
      list-style: none;
      padding: 0;
      margin: 0;

      li {
        margin-bottom: 1rem;
      }

      .footer-link {
        color: #4a4a4a;
        text-decoration: none;
        transition: all 0.3s ease;
        position: relative;
        padding-left: 1.2rem;
        font-size: 1.05rem;

        &:before {
          content: "›";
          position: absolute;
          left: 0;
          color: #ee800a;
          font-weight: bold;
          font-size: 1.2rem;
        }

        &:hover {
          color: #ee800a;
          transform: translateX(5px);
        }
      }
    }
  }

  .footer-contact-section {
    .footer-contact-list {
      list-style: none;
      padding: 0;
      margin: 0;

      .footer-contact-item {
        display: flex;
        align-items: flex-start;
        margin-bottom: 1.8rem;

        .contact-icon {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 44px;
          height: 44px;
          border-radius: 50%;
          background: white;
          margin-right: 1rem;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
          color: #ee800a;
          flex-shrink: 0;
          transition: all 0.3s ease;

          svg {
            width: 20px;
            height: 20px;
          }
        }

        &:hover .contact-icon {
          transform: scale(1.1);
          box-shadow: 0 6px 15px rgba(238, 128, 10, 0.15);
        }

        .footer-link {
          color: #4a4a4a;
          text-decoration: none;
          transition: color 0.3s ease;
          font-size: 1.05rem;
          line-height: 1.7;

          &:hover {
            color: #ee800a;
          }
        }

        .footer-address {
          font-style: normal;
          line-height: 1.7;
          color: #4a4a4a;
          font-size: 1.05rem;
        }
      }
    }
  }

  .footer-info-section {
    .hours-container {
      margin-bottom: 2.5rem;

      .day-group {
        display: flex;
        justify-content: space-between;
        margin-bottom: 0.9rem;
        line-height: 1.6;

        .day {
          font-weight: 500;
          color: #09283f;
          margin: 0;
          font-size: 1.05rem;
        }

        .hours {
          color: #4a4a4a;
          margin: 0;
          font-size: 1.05rem;
        }
      }
    }

    .newsletter {
      background: white;
      padding: 1.5rem;
      border-radius: 8px;
      box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);

      .newsletter-title {
        font-size: 1.1rem;
        font-weight: 600;
        margin-top: 0;
        margin-bottom: 1rem;
        color: #09283f;
      }

      .newsletter-form {
        display: flex;
        flex-direction: column;
        gap: 0.8rem;

        .newsletter-input {
          padding: 0.8rem 1rem;
          border: 1px solid #e0e0e0;
          border-radius: 4px;
          font-size: 0.95rem;

          &:focus {
            outline: none;
            border-color: #ee800a;
            box-shadow: 0 0 0 2px rgba(238, 128, 10, 0.1);
          }
        }

        .newsletter-button {
          background: linear-gradient(135deg, #ee800a, #ff7043);
          color: white;
          border: none;
          padding: 0.8rem;
          border-radius: 4px;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.3s ease;

          &:hover {
            transform: translateY(-2px);
            box-shadow: 0 4px 10px rgba(238, 128, 10, 0.2);
          }
        }
      }
    }
  }

  .footer-bottom {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-top: 2rem;
    position: relative;

    @media (max-width: 768px) {
      flex-direction: column;
      gap: 1.2rem;
      text-align: center;
    }

    .footer-copyright {
      font-size: 0.95rem;
      color: #4a4a4a;
      margin: 0;
    }

    .footer-legal-links {
      display: flex;
      gap: 1rem;
      align-items: center;

      .separator {
        color: #ccc;
      }
    }

    .legal-link {
      font-size: 0.95rem;
      color: #4a4a4a;
      text-decoration: none;
      transition: color 0.3s ease;

      &:hover {
        color: #ee800a;
      }
    }
  }
}
</style>
